module.exports = __webpack_public_path__ + "img/logo.135c6794.png";